/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { renderToString } from 'react-dom/server';
import { spring, StaggeredMotion } from 'react-motion';

import SharingPopup from 'components/SharingPopup';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import { storageKeys } from 'settings';

const trackShare = (type, value, title) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj);
      APIHandler.trackEvent(appId, email, 'collateral', type, value, title).then(() => {});
    });
  });
};

const Collection = (props) => {
  const { content, header } = props;

  // Dynamically Create enough animation starting values
  const startingValues = [];
  Object.keys(content).map(() => {
    const newObj = {};
    newObj.pos = 0;
    return startingValues.push(newObj);
  });

  const fancyOptions = (url, image, title) => ({
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: 'x',
    },
    baseClass: 'customBox',
    buttons: ['thumbs', 'share', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={url} image={image} title={title} />),
    },
    caption: title,
  });

  let headerTitle = header;
  if (header === 'Videos') {
    headerTitle = i18n.translate('missing.videos');
  } else if (header === 'Photos') {
    headerTitle = i18n.translate('missing.images');
  } else if (header === 'Images') {
    headerTitle = i18n.translate('missing.images');
  } else if (header === 'Region Map') {
    headerTitle = i18n.translate('missing.regionMap');
  }

  console.log(header, 'headerTitle');

  return (
    <div className="collection__Container">
      <div className="collection__Container--title">
        <h3>{headerTitle}</h3>
      </div>
      <StaggeredMotion
        defaultStyles={startingValues}
        styles={(prevInterpolatedStyles) =>
          prevInterpolatedStyles.map((_, i) =>
            i === 0
              ? { pos: spring(1, { stiffness: 320, damping: 28 }) }
              : { pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }) },
          )
        }
      >
        {(styles) => (
          <div className="collection__Grid">
            {Object.values(content).map((item, index) => {
              const { pageID, title, url, type } = item;
              let { image } = item;
              const ogImage = image;
              image = `${image.replace('front.travpromobile.com', 'travprocdn.imgix.net')}?w=800`;

              if (type === 'pdf') {
                return (
                  <div
                    className="collection_Card"
                    key={pageID}
                    style={{ opacity: `${styles[index].pos}` }}
                    href={`https://stack.travpromobile.com/viewer.php?file=${url}`}
                    data-fancybox={`https://stack.travpromobile.com/viewer.php?file=${url}`}
                    data-options={JSON.stringify(
                      fancyOptions(`https://stack.travpromobile.com/viewer.php?file=${url}`, image, title),
                    )}
                    data-caption={title}
                    onClick={() => trackShare(url, url, title)}
                  >
                    <img key={url} src={image} alt={title} />
                    <div className="title" dangerouslySetInnerHTML={{ __html: title }} />
                  </div>
                );
              }

              if (type === 'weblink') {
                return (
                  <div className="collection_Card" key={pageID} style={{ opacity: `${styles[index].pos}` }}>
                    <a href={url} target="_blank" rel="noreferrer noopener" onClick={() => trackShare(url, url, title)}>
                      <img key={url} src={image} href={url} alt={title} />
                      <div className="title" dangerouslySetInnerHTML={{ __html: title }} />
                    </a>
                  </div>
                );
              }

              if (type === 'photo') {
                return (
                  <div
                    className="collection_Card"
                    key={pageID}
                    style={{ opacity: `${styles[index].pos}` }}
                    data-options={JSON.stringify(fancyOptions(image, image, title))}
                    data-caption={title}
                    onClick={() => trackShare(image, image, title)}
                    href={ogImage}
                    data-fancybox={ogImage}
                  >
                    <img key={image} src={image} alt={title} />
                    <div className="title" dangerouslySetInnerHTML={{ __html: title }} />
                  </div>
                );
              }

              return (
                <div
                  className="collection_Card"
                  key={pageID}
                  style={{ opacity: `${styles[index].pos}` }}
                  data-options={JSON.stringify(fancyOptions(url, image, title))}
                  data-caption={title}
                  onClick={() => trackShare(url, url, title)}
                  href={url}
                  data-fancybox={url}
                >
                  <img key={url} src={image} alt={title} />
                  <div className="title" dangerouslySetInnerHTML={{ __html: title }} />
                </div>
              );
            })}
          </div>
        )}
      </StaggeredMotion>
    </div>
  );
};

export default Collection;

Collection.propTypes = {
  content: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  header: PropTypes.string,
};

Collection.defaultProps = {
  header: '',
};
